var map = {
	"./alfa.svg": 7931,
	"./ozon.svg": 1991,
	"./qiwi.svg": 4745,
	"./sberbank.svg": 6807,
	"./tinkoff.svg": 7514,
	"./tinkoffOLD.svg": 3193,
	"./tochka.svg": 9925,
	"./vtb.svg": 8213,
	"./wb.svg": 1364
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2015;